// extracted by mini-css-extract-plugin
export var errorsContainer = "_sm-1";
export var link = "_sm-0";